<template>
  <span v-if="piiAuthorized">
    <el-dropdown
        trigger="click"
        :disabled="!isReady"
        @command="handlePLCRequest">
      <span class="choose_plc_request_button">
        <span style="text-decoration: underline;">
          <i
              v-if="!isReady"
              class="el-icon-loading el-icon--left"></i>
          Start PLC Request
        </span>
        <i class="el-icon-caret-bottom el-icon--right"></i>
      </span>
      <el-dropdown-menu
          v-if="isReady"
          slot="dropdown"
          class="plc-request-dropdown"
          style="max-height: unset !important; overflow: unset !important;">
        <el-tooltip
            :disabled="eligibility.replacement.isUserAllowed && !eligibility.replacement.noBypassable"
            placement="right"
            :content="replacementTooltip">
          <span>
            <el-dropdown-item
                v-acl.show="{permission: 'create', on: 'ReplaceRequest'}"
                class="plc_request_item"
                type="text"
                :disabled="disableReplacement"
                :class="{'new-disabled': disableReplacement}"
                command="replace">
              Replace Device
            </el-dropdown-item>
          </span>
        </el-tooltip>
        <el-tooltip
            :disabled="eligibility.parts.isUserAllowed && !eligibility.parts.noBypassable"
            placement="right"
            :content="partsTooltip">
          <span>
            <el-dropdown-item
                v-acl.show="{permission: 'create', on: 'PartsRequest'}"
                class="plc_request_item"
                type="text"
                :disabled="disableParts"
                :class="{'new-disabled': disableParts}"
                command="parts">
              Send Parts
            </el-dropdown-item>
          </span>
        </el-tooltip>

        <el-tooltip
            :disabled="eligibility.refund.isUserAllowed && !eligibility.refund.noBypassable"
            placement="right"
            :content="refundTooltip">
          <span>
            <el-dropdown-item
                v-acl.show="{permission: 'create', on: 'RefundRequest'}"
                class="plc_request_item"
                type="text"
                :disabled="disableRefund"
                :class="{'new-disabled': disableRefund}"
                command="refund">
              Refund
            </el-dropdown-item>
          </span>
        </el-tooltip>
      </el-dropdown-menu>
    </el-dropdown>
  </span>
</template>

<script>
import { createNamespacedHelpers as h } from "vuex";
const { mapGetters: accountGetters } = h("db/account");
import { DeviceWarrantyAndEligibilityPolicy } from "@/helpers/DeviceWarrantyAndEligibilityPolicy";

export default {
  name: "PLCRequestDropdown",
  props: {
    /**
     * @type { DeviceWarrantyAndEligibilityPolicy }
     */
    eligibility: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    ...accountGetters(["piiAuthorized"]),
    isReady() {
      return this.eligibility?.hasOwnProperty("doorbotId");
    },
    partsTooltip() {
      return this.getTooltip("Part", this.eligibility.parts);
    },
    refundTooltip() {
      return this.getTooltip("Refund", this.eligibility.refund);
    },
    replacementTooltip() {
      return this.getTooltip("Replacement", this.eligibility.replacement);
    },
    disableParts() {
      return (
        !this.eligibility.parts.isUserAllowed ||
        this.eligibility.parts.noBypassable
      );
    },
    disableRefund() {
      return (
        !this.eligibility.refund.isUserAllowed ||
        this.eligibility.refund.noBypassable
      );
    },
    disableReplacement() {
      return (
        !this.eligibility.replacement.isUserAllowed ||
        this.eligibility.replacement.noBypassable
      );
    },
  },
  methods: {
    getTooltip(type, service) {
      if (service.noBypassable) {
        let message = service.nonBypassableRestrictions[0];
        return `Non-bypassable restriction: ${message}`;
      }

      return service.ineligibilityReasons.length === 0
        ? `${type} Request`
        : "Contact your supervisor";
    },
    handlePLCRequest(command) {
      this.$emit("plc-request", command);
    },
  },
};
</script>

<style scoped>
.choose_plc_request_button {
  color: #1476ad;
}

.plc_request_item {
  width: 260px;
  font-family: "Equip", sans-serif !important;
  font-style: normal;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #424242 !important;
  padding: 8px 16px !important;
}

.plc-request-dropdown {
  margin-top: 0 !important;
  padding: 8px 0 !important;
  border: 1px solid #81919f !important;
}

.new-disabled {
  color: #81919f !important;
}

.plc_request_item:hover {
  background: #eff8fc;
}
</style>
